export default {
  companyUrl: 'https://stage-www.lwtears.com',
  digitalAssetsUrl: 'https://a-z-educator-content-stage.lwtears.com',
};
